import { QueryParameterSchema } from '../../context/QueryParameterContext';

export const fieldsOfStudyFilter: QueryParameterSchema<'fieldsOfStudy'> = {
  getDefaultValue: () => [],
  getValue: ({ parameters }) => parameters.fieldsOfStudy,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    fieldsOfStudy: (urlSearchParams.get('filter[fieldsOfStudy]') || '').split(','),
  }),
  toUrlSearchParams: ({ value }) => ({ 'filter[fieldsOfStudy]': value.join(',') }),
  toSearchQuery: ({ value }) => {
    if (!value || value.length === 0) return {};
    return { 'filter[fieldOfStudyIds]': value };
  },
  sanitize: ({ value, staticProps }) => {
    const {
      referenceData: { fieldsOfStudy },
    } = staticProps;
    return { fieldsOfStudy: value.filter((s) => !!s && !!fieldsOfStudy[s]?.name) };
  },
  getSummaryItems: ({
    value,
    staticProps: {
      referenceData: { fieldsOfStudy },
    },
  }) => {
    return value.map((fieldOfStudy) => ({
      filterKey: 'fieldsOfStudy',
      key: fieldOfStudy,
      label: `${fieldsOfStudy[fieldOfStudy]?.name}`,
      value: fieldOfStudy,
    }));
  },
  removeParam: ({ value, removedValue }) => {
    return { fieldsOfStudy: value.filter((item) => item !== removedValue) };
  },
};
